import { render, staticRenderFns } from "./AddHub.vue?vue&type=template&id=2297e050"
import script from "./AddHub.vue?vue&type=script&lang=js"
export * from "./AddHub.vue?vue&type=script&lang=js"
import style0 from "./AddHub.vue?vue&type=style&index=0&id=2297e050&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports